import { state, patch, emitChange } from "../../state/store.js";
import { sortChatsForList } from "../../views/Chat.helpers.ts";

export function handleCrmSyncMessage(msg) {
  if (msg.op === "snapshot" && msg.payload) {
    const payload = msg.payload;
    patch({
      leads: Array.isArray(payload.leads) ? payload.leads : state.leads,
      funnels: Array.isArray(payload.funnels) && payload.funnels.length ? payload.funnels : state.funnels,
      whatsappSession: payload.whatsappSession || state.whatsappSession,
      chats: Array.isArray(payload.whatsappChats) ? sortChatsForList(payload.whatsappChats) : state.chats,
    });
    return true;
  }
  if (msg.op === "lead.upsert" && msg.payload) {
    const lead = msg.payload;
    const idx = state.leads.findIndex((item) => item.id === lead.id);
    if (idx >= 0) state.leads[idx] = lead;
    else state.leads.push(lead);
    emitChange();
    return true;
  }
  if (msg.op === "lead.delete" && msg.payload?.id) {
    state.leads = state.leads.filter((item) => item.id !== msg.payload.id);
    emitChange();
    return true;
  }
  if (msg.op === "funnels.replace" && msg.payload?.funnels) {
    patch({
      funnels: msg.payload.funnels,
      activeFunnelId: msg.payload.activeFunnelId || state.activeFunnelId,
    });
    return true;
  }
  return false;
}
